export default __webpack_public_path__ + "static/media/bag.c23d9e50.svg";